import { render, staticRenderFns } from "./super_sidebar.vue?vue&type=template&id=c48cf5d0"
import script from "./super_sidebar.vue?vue&type=script&lang=js"
export * from "./super_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports